module.exports = __webpack_public_path__ + "static/media/AccountMypage.a8691aa1.svg";